// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Management Page – component-specific (layout from CrudPage.css) */

.um-page {
  padding-top: 20px;
}

.um-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.um-toolbar .um-search-input {
  flex: 1 1;
  min-width: 220px;
  max-width: 420px;
}

/* User cell in table */
.um-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.um-user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  flex-shrink: 0;
}

.um-user-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 15px;
}

.um-user-email {
  font-size: 15px;
  color: #94a3b8;
  margin-top: 1px;
}

/* Role and status badges */
.um-role-badge,
.um-status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.um-role-badge.admin {
  background: #fef3c7;
  color: #92400e;
}

.um-role-badge.user {
  background: #dbeafe;
  color: #1e40af;
}

.um-status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.um-status-badge.inactive {
  background: #fee2e2;
  color: #991b1b;
}

/* Action buttons in table */
.um-action-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.um-action-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
}

.um-action-btn:hover {
  background: #e5e7eb;
}

.um-action-btn.edit:hover {
  background: #dbeafe;
  border-color: #3b82f6;
  color: #2563eb;
}

.um-action-btn.reset-password:hover {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #d97706;
}

.um-action-btn.delete:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.um-action-btn svg {
  width: 16px;
  height: 16px;
}

/* Modal form spacing */
.um-form .crud-form-section:first-of-type,
.um-edit-form .crud-form-section:first-of-type {
  margin-top: 0;
  padding-top: 4px;
}

.um-modal-subtitle {
  padding: 0 28px;
  margin: 8px 0 0;
  font-size: 15px;
  color: #6b7280;
}

.um-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #374151;
}

.um-checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
}

@media (max-width: 768px) {
  .um-search-input-container {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManagementPage.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* User Management Page – component-specific (layout from CrudPage.css) */\n\n.um-page {\n  padding-top: 20px;\n}\n\n.um-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.um-toolbar .um-search-input {\n  flex: 1;\n  min-width: 220px;\n  max-width: 420px;\n}\n\n/* User cell in table */\n.um-user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.um-user-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.um-user-name {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.um-user-email {\n  font-size: 15px;\n  color: #94a3b8;\n  margin-top: 1px;\n}\n\n/* Role and status badges */\n.um-role-badge,\n.um-status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.um-role-badge.admin {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.um-role-badge.user {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.um-status-badge.active {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.um-status-badge.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Action buttons in table */\n.um-action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.um-action-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.um-action-btn:hover {\n  background: #e5e7eb;\n}\n\n.um-action-btn.edit:hover {\n  background: #dbeafe;\n  border-color: #3b82f6;\n  color: #2563eb;\n}\n\n.um-action-btn.reset-password:hover {\n  background: #fef3c7;\n  border-color: #f59e0b;\n  color: #d97706;\n}\n\n.um-action-btn.delete:hover {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #dc2626;\n}\n\n.um-action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Modal form spacing */\n.um-form .crud-form-section:first-of-type,\n.um-edit-form .crud-form-section:first-of-type {\n  margin-top: 0;\n  padding-top: 4px;\n}\n\n.um-modal-subtitle {\n  padding: 0 28px;\n  margin: 8px 0 0;\n  font-size: 15px;\n  color: #6b7280;\n}\n\n.um-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.um-checkbox-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #3b82f6;\n}\n\n@media (max-width: 768px) {\n  .um-search-input-container {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
